import { render } from "./SearchBar.vue?vue&type=template&id=227b9a8a&scoped=true&ts=true"
import script from "./SearchBar.vue?vue&type=script&lang=ts"
export * from "./SearchBar.vue?vue&type=script&lang=ts"

import "./SearchBar.vue?vue&type=style&index=0&id=227b9a8a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-227b9a8a"]])

export default __exports__